
export default {
    registerForm: {
        registerFormData: {},
        isFormLoadSuccessful: false,
        isRegisterSuccessful: false,
        userRegistrationMessages: [],
        isResendEmailVerificationSuccessful: false,
        resendEmailVerificationMessages: [],
        userName: ''
    },
    itemListForm: {
        isFormLoadSuccessful: false,
        itemListFormData: {},
        itemListErrorMessages: []
    },
    upgradeAccountForm: {
        isUpgradeSuccessful: false,
        accountUpgradeMessages: [],
        upgradeToOneClubFormData: {}
    },
    userAddress: {
        isUserAddressSearchSuccessful: false,
        suggestedAddresses: [],
        searchAddressMessages: '',
        isUserAddressRetrieveSuccessful: false,
        retrieveAddressMessages: '',
        retrievedUserAddress: {}
    },
    basket: {
        isPaymentAttemptSuccessful: true,
        purchaseAttemptMessages: []
    },
    signInForm: {
        signInFormData: {},
        isFormLoadSuccessful: false,
        isSignInSuccessful: false,
        isUserLastLogInDataUpdated: false,
        userLastLogInDataErrorMessages: [],
        signInMessages: [],
        isSignOutSuccessful: false,
        signOutMessages: [],
        isNewPasswordRequired: false,
        cognitoUser: {},
        isNewPasswordRequiredFormDataLoadedSuccessful: false,
        loadPasswordRequiredFormDataMessages: [],
        newPasswordRequiredFormData: {},
        isNewPasswordSavedSuccessful: false,
        newPasswordSavedMessages: [],
        signInSuccessFormData: {}
    },
    forgotPasswordForm: {
        forgotPasswordFormData: {},
        isFormLoadSuccessful: false,
        forgotPasswordMessages: [],
        isForgotPasswordSuccessful: false
    },
    resetPasswordForm: {
        resetPasswordFormData: {},
        isFormLoadSuccessful: false,
        resetPasswordMessages: [],
        isResetPasswordSuccessful: false
    },
    verifyEmailForm: {
        verifyEmailFormData: {},
        isFormLoadSuccessful: false,
        verifyEmailMessages: [],
        isVerifyEmailSuccessful: false
    },
    userAccount: {
        isTicketsDataLoadedSuccessful: false,
        isUserAccountDataLoadedSuccessful: false,
        isAccountPageRefresh: false,
        isUserNotSignedIn: false,
        isOrderHistoryLoadedSuccessful: false,
        areOrderDetailsLoadedSuccessful: false,
        areOrderHistoryPagesLoadedSuccessful: false,
        isUserDetailsUpdatedSuccessful: false,
        isUserTicketsDataLoadedSuccessful: false,
        isPdfFileDownloadedSuccessful: false,
        isUserAccountRemovedSuccessful: false,
        areUserAddressesUpdatedSuccessful: false,
        isUserPasswordChangedSuccessful: false,
        isUserUpdatingEmail: false,
        homePageTicketsData: {},
        userAccountData: {},
        orderHistoryData: [],
        orderDetails: {},
        userTicketsData: [],
        orderHistoryPages: 0,
        loadHomePageTicketsDataErrorMessages: [],
        downloadPdfFileErrorMessages: [],
        updateUserDetailsMessages: [],
        updateUserAddressesMessages: [],
        changePasswordMessages: [],
        userAddedToAddressBookSuccessful: false,
        saveUserToAddressBookErrorMessages: [],
        referralCode: '',
        isReferralCodeLoaded: false,
    },
    apiStatus: {
        apiCallsInProgress: 0,
        apiErrorMessages: []
    }
};
